import Component from '@cell/cell-core/component/component';

import './marketing-header.scss';

class MarketingHeader extends Component {
  constructor() {
    super();

    this.selectors = {
      sticky: 'MarketingHeader--Sticky',
    };

    this.handleIntersection = this.handleIntersection.bind(this);

    this.handleCartLineItemUpdate = this.handleCartLineItemUpdate.bind(this);

    this.setHeightCSSVariable = this.setHeightCSSVariable.bind(this);
  }

  componentDidMount() {
    const stickyObserver = new IntersectionObserver(this.handleIntersection, {
      threshold: [1],
    });

    stickyObserver.observe(this.parentNode);

    globalThis.on('cart-drawer.render', this.handleCartLineItemUpdate);

    globalThis.on('resize', this.setHeightCSSVariable);

    this.setHeightCSSVariable();
  }

  handleIntersection(entries) {
    const entry = entries[0];

    if (entry.intersectionRatio < 1) {
      this.classList.add(this.selectors.sticky);
    } else {
      this.classList.remove(this.selectors.sticky);
    }
  }

  handleCartLineItemUpdate(event) {
    const { itemCount } = event.data;
    const itemCountElement = this.querySelector('.MarketingHeader__CartAction .Count');

    itemCountElement.textContent = itemCount;

    if (itemCount > 0) {
      itemCountElement.style.display = '';
    } else {
      itemCountElement.style.display = 'none';
    }
  }

  setHeightCSSVariable() {
    document.documentElement.style.setProperty('--site-header-height', `${this.clientHeight}px`);
  }
}

customElements.define('maketing-header', MarketingHeader);
